/**
 * Created by Mike Naughton on 12/05/2017.
 */

import BaseListView from "core/views/Field/BaseListView";
import _ from "underscore";
var STORE_SEPARATOR = ",";
var DISPLAY_SEPARATOR = ", ";

export default BaseListView.extend({
  template: _.template(
    '<span style="display:none;" class="field-value"><%-value%></span><span class="field-text"></span>'
  ),

  itemTemplate: function (item) {
    return item.text;
  },

  serializeItems: function (items) {
    var thisValue = this.getValue();

    if (!_.isArray(thisValue)) {
      thisValue = String(thisValue).split(STORE_SEPARATOR);
    }

    return _.filter(
      items,
      function (item) {
        return _.contains(thisValue, item.value);
      },
      this
    );
  },

  insertItem: function (item) {
    var $fieldText = this.$(".field-text");
    var fieldTextContent = $fieldText.html();

    $fieldText.html(fieldTextContent + DISPLAY_SEPARATOR + item);
  },

  getControlValue: function () {
    return this.$(".field-value").html();
  },

  setControlValue: function () {
    var self = this;

    this.load.done(function (options, items) {
      items = self.serializeItems(items);
      texts = _.pluck(items, "text");
      values = _.pluck(items, "value");

      if (items.length) {
        self.$(".field-value").html(values.join(STORE_SEPARATOR));
        self.$(".field-text").html(texts.join(DISPLAY_SEPARATOR));
      } else {
        self.$("span").html("");
      }
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/CheckListView.js
// module id = 856
// module chunks = 1